import { AiPreferencesAdapter } from '~/services/adapters/ai-preferences.adapter';

export class AiPreferencesService extends AiPreferencesAdapter {}
